<template>
  <section>
    <div class="grade">
      <div class="grade-btns">
        <span>班级添加</span>
        <el-button
          type="text" @click="handleControl(null, 'add')"
        >
          添加班级
        </el-button
        >
      </div>
      <div class="grade-table">
        <com-table :data="list" stripe border :configs="mineInfo.obj.table3">
          <template v-slot:operate="{ row }">
            <el-button
              type="text" @click="handleControl(row, 'edit')"
            >
              编辑
            </el-button
            >
            <span class="pad-row4">/</span>
            <el-button
              type="text" @click="handleControl(row, 'del')"
            >
              删除
            </el-button
            >
          </template>
        </com-table>
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comTable from '@/components/comTable'
export default {
  name: 'ComGrade',
  components: { comTable },
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      mineInfo: mock.mine.set.viewInfo
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleControl(v, x) {
      this.$emit('control', v, x)
    }
  }
}
</script>

<style scoped lang="scss">
.grade {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  &-btns {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    > button {
      @include fun-btn(1);
    }
  }
  &-table {
    flex: 1;
    width: 100%;
  }
}
</style>
